// Note that the StreemAPI automatically retries some http codes (mainly 401 and 429) using postApiMiddleware:
//   see web/packages/api/src/base_api.ts.
//   This function allows selectively retrying a single endpoint call without modifying the middleware, which
//   affects every API call.
export async function retryWithBackoff(fn, maxAttempts, onFailedAttempt) {
    let attempt = 1;
    do {
        try {
            const result = await fn();
            return result;
        }
        catch (e) {
            onFailedAttempt && onFailedAttempt(attempt, e);
            attempt++;
            if (attempt > maxAttempts) {
                return e;
            }
            await waitForBackoffPeriod(attempt - 1);
        }
    } while (attempt <= maxAttempts);
}
const BASE_INTERVAL = 100; // wait at least 100ms between retries
const MULTIPLIER = 10; // will add 10 ^ previousFailures to BASE_INTERVAL
function waitForBackoffPeriod(previousFailures) {
    return new Promise(res => setTimeout(res, BASE_INTERVAL + MULTIPLIER ** previousFailures));
}
//# sourceMappingURL=retry_with_backoff.js.map